import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/@services/common.service';
import { Investment, Investor } from 'src/models/investment.model';
import { CommonPagesService } from '../../common-pages.service';

@Component({
    selector: 'app-investor-history',
    templateUrl: './investor-history.component.html',
    styleUrls: ['./investor-history.component.scss'],
    standalone: false
})
export class InvestorHistoryComponent implements OnInit {
  //#region properties
  currentYear: number;
  lastYear: number;
  currentInvestor: Investor = { InvestorDisplayName: 'x' };
  @Input() investorSelected: string;
  @Input() isFromInvestmentsList: string;
  supplierId: string;
  @Input() selectedData: Investment;
  currentYearApiInvestorsData: Investor[] = [];
  lastYearApiInvestorsData: Investor[] = [];
  multipleEmails: string[] = [];
  //#endregion

  constructor(
    public _cpS: CommonPagesService,
    private route: ActivatedRoute,
    private _cS: CommonService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    //get site id for URL
    this.supplierId = this.route.snapshot.paramMap.get('supplierId');
    this.currentYear = new Date().getFullYear();
    // this.currentInvestor = { InvestorDisplayName: 'x' };
    this.lastYear = new Date().getFullYear() - 1;
    this._cpS.currentInvestorDetails.subscribe((res: Investor) => {
      if (res != null) {
        this.currentInvestor = res;
        if (this.currentInvestor.email) {
          this.multipleEmails = this.currentInvestor.email.split(',');
        }
      }
    });
    this._cS.investmentHistoryRecords.subscribe(
      (res: { currentYearData; lastYearData }) => {
        if (res != null) {
          this.currentYearApiInvestorsData = res.currentYearData
            ? res.currentYearData
            : [];
          this.lastYearApiInvestorsData = res.lastYearData
            ? res.lastYearData
            : [];
        }
      }
    );
    if (
      !this.investorSelected &&
      !this.selectedData &&
      !this.isFromInvestmentsList
    ) {
      this.currentInvestor = null;
    }
  }
  navigateToActivity(year: number) {
    this._router.navigate(['/supplier/' + this.supplierId + '/activity-detailed'], {
      queryParams: {
        filterYear: year,
        filterName: this.currentInvestor?.companyName,
      },
    });
  }
  getStatus(data: Investment) {
    const activityStatus = data.BrooklynInvestmentStatus;
    let status: string;
    this._cS.investmentStatus.every((element: any) => {
      if (element.statusEnum == activityStatus) {
        status = element.statusText;
        return false;
      }
      return true;
    });
    return status;
  }
}
